"use client";
import styles from "./InputDesign.module.css";

export const PersonalInfoForm = ({ 
  isEditable, 
  showPersonalInfo, 
  setShowPersonalInfo, 
  formData, 
  handleInputChange, 
  handleSaveChanges, 
  toggleEditing 
}) => {
  return (
    <section className={styles.personalInfoCard}>
      <div className={styles.formContainer}>
        <div className={styles.formHeader}>
          <h2 className={styles.formTitle}>Personal Information</h2>
          <button 
            className={`${styles.editButton} ${isEditable ? styles.saveButton : ''}`}
            onClick={toggleEditing}
          >
            {isEditable ? 'Save' : 'Edit'}
          </button>
        </div>
        
        <div 
          className={styles.sectionHeader}
          onClick={() => setShowPersonalInfo(!showPersonalInfo)}
        >
          <h3>Personal Information</h3>
          <i className={`fas fa-chevron-${showPersonalInfo ? 'up' : 'down'}`}></i>
        </div>
        
        {showPersonalInfo && (
          <form onSubmit={(e) => { e.preventDefault(); handleSaveChanges(); }}>
            <div className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>First Name</label>
              <input
                type="text"
                value={formData?.firstName || ''}
                onChange={(e) => handleInputChange(e, 'firstName')}
                className={styles.fieldInput}
                disabled={!isEditable}
              />
            </div>
            <div className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>Last Name</label>
              <input
                type="text"
                value={formData?.lastName || ''}
                onChange={(e) => handleInputChange(e, 'lastName')}
                className={styles.fieldInput}
                disabled={!isEditable}
              />
            </div>
            <div className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>Email Address</label>
              <input
                type="email"
                value={formData?.email || ''}
                onChange={(e) => handleInputChange(e, 'email')}
                className={styles.fieldInput}
                disabled={!isEditable}
              />
            </div>
            <div className={styles.phoneFieldGroup}>
              <label className={styles.phoneFieldLabel}>Mobile Number</label>
              <div className={styles.phoneInputContainer}>
                <div className={styles.countrySelector}>
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/54dc48ef9396b0be945a6d4ce5cd7fadc94ed845?placeholderIfAbsent=true"
                    alt="Country flag"
                    className={styles.flagIcon}
                  />
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/27e6b1fafea4b0a9555d2e014184291f0033845e?placeholderIfAbsent=true"
                    alt="Dropdown"
                    className={styles.dropdownIcon}
                  />
                </div>
                <input
                  type="tel"
                  value={formData?.phone || ''}
                  onChange={(e) => handleInputChange(e, 'phone')}
                  className={styles.phoneNumber}
                  disabled={!isEditable}
                />
              </div>
            </div>
            {isEditable && (
              <div className={styles.saveButtonContainer}>
                <button type="submit" className={styles.saveButton}>
                  Save Changes
                </button>
              </div>
            )}
          </form>
        )}
      </div>
    </section>
  );
};
